export const css = {
	root: '_2dIwupBE',
	cell: '_1te9Jb8P',
	sortable: '_4znER7Z8',
	sorted: '_1K99V9X-',
	sort: 'YGGb-C5H',
	filter: '_1g3i5UuK',
	' _key': 'ascm-theme/dojo/grid-header'
};

export default css;
